import { Component, Emit, Prop, PropSync, Vue } from 'vue-property-decorator'
import {
    ConsultationToolbarSelectorTypeEnum
} from '@/modules/diagnosisModule/views/form/modals/consultation/modal-toolbar/diagnosis-consultation-modal-toolbar.model'

@Component
export default class DiagnosisConsultationModalToolbar extends Vue {
    @Prop({ type: Boolean, default: false }) readonly pathologistView!: boolean
    @Prop({ type: Boolean, default: false }) readonly consultantView!: boolean
    @Prop({ type: Number, default: 0 }) readonly consultationsCount!: number
    @Prop({ type: Number, default: 0 }) readonly consultantsCount!: number

    @PropSync('selectorType') syncedSelectorType!: ConsultationToolbarSelectorTypeEnum

    @Emit()
    create(): void {}

    get canSelect(): boolean {
        return this.pathologistView || this.consultantView
    }

    get selectorTypes(): typeof ConsultationToolbarSelectorTypeEnum {
        return ConsultationToolbarSelectorTypeEnum
    }

    setSelectorType(selectorType: ConsultationToolbarSelectorTypeEnum): void {
        this.syncedSelectorType = selectorType
    }
}
